import {
    AutoProviderLogo,
    PrequalsFinancingInformationContainer,
    PrequalsPlansContainer,
} from '@servicetitan/financing-plans-shared';
import { plansPanel, wrapper } from '../workflow/ApplicationWorkflow.module.scss';
import { Alert, Flex } from '@servicetitan/anvil2';
import { ErrorBoundary } from '@servicetitan/financing-utils-shared';
import { useProviderConfig } from '@servicetitan/financing-workflow-shared';

interface SelectPlanStepProps {
    onPlanSelected?: () => void;
}

export const PrequalsSelectPlanStep = (props: SelectPlanStepProps) => {
    const { ...restProps } = props;
    const { prequalAlertText } = useProviderConfig();

    return (
        <div className={plansPanel} style={{ width: '100%' }}>
            <div className={wrapper}>
                <Flex direction="column" gap="4">
                    <ErrorBoundary actionCausingError="loading available plans">
                        <AutoProviderLogo />
                        {prequalAlertText && <Alert status="info" title={prequalAlertText} />}
                        <PrequalsFinancingInformationContainer />
                        <PrequalsPlansContainer {...restProps} />
                    </ErrorBoundary>
                </Flex>
            </div>
        </div>
    );
};
